<template lang="pug">
  .div
    .dialog-container(id="DialogExtractPlayitems-container" v-if='this.$store.state.Medium.playitems_selected_right.length > 0')
      h4 {{$t('Extract into')}}&nbsp;{{ choice === 'PlayList' ? $t('Playlist') : $t('Layout')}}
        span &nbsp;
        font-awesome-icon(v-if="choice === 'PlayList'", icon="film")
        font-awesome-icon(v-else, icon="layer-group")
      hr.header
      el-row
        el-col.col-left(:span="10")
          h4 {{$t('Playitems Extracted')}}:
          hr.header
          ShortMediaList(id="DialogExtractPlayitems-playitemsList" ref='childrenList', :items='this.$store.state.Medium.playitems_selected_right.map(pi => pi.Medium)', :showThumbs="true", :showMediaIcons="true")
        el-col.col-middle(:span="4")
          el-button.confirm(id="DialogExtractPlayitems-extractButton" v-if='!saving', type="success", :disabled='!newPlayListHasName', @click="extractPlayListWithPlayitems()", circle)
            font-awesome-icon.linker-icon(icon="film")
            | &nbsp; {{$t("Extract")}} &nbsp;
          el-button.confirm.spinner(v-if='saving', type="primary", circle)
            font-awesome-icon.spinner-icon.fa-pulse(icon="spinner")
            .spinner-text {{ $t('extracting...') }}
        el-col.col-right(:span="10")
          .playlist
            h4 {{ choice === 'PlayList' ? $t('Playlist') : $t('Layout')}}:
            hr.header
            el-form(@submit='extractPlayListWithPlayitems()', @keyup.enter='extractPlayListWithPlayitems()', v-on:submit.native.prevent="extractPlayListWithPlayitems()")
              el-form-item(:label="$t('Name')")
                el-input(id="DialogExtractPlayitems-playlistNameInput" v-model="playlistName", type="text", :placeholder="$t(choice === 'PlayList' ? $t('Playlist name') : $t('Layout name'))")
              el-form-item(v-if='choice === "PlayListLayout"', :label="$t('Width')")
                el-input(id="DialogExtractPlayitems-playlistWidthInput" v-model="layoutData.playListLayoutWidth", type="text", placeholder="Width px")
              el-form-item(v-if='choice === "PlayListLayout"', :label="$t('Height')")
                el-input(id="DialogExtractPlayitems-playlistHeightInput" v-model="layoutData.playListLayoutHeight", type="text", placeholder="Height px")
</template>

<script>
import Vue from 'vue'
import ShortMediaList from '../Common/ShortMediaList'

export default {
  props: ['choice'],
  components: {
    ShortMediaList
  },
  mounted () {
    if (this.$refs.input_name) this.$refs.input_name.focus()
  },
  updated () {
    if (this.$refs.input_name) this.$refs.input_name.focus()
  },

  data () {
    return {
      saving: false,
      playlistName: '',
      layoutData: {
        playListLayoutWidth: 1920,
        playListLayoutHeight: 1080,
        type: 'PlayListLayout'
      }
    }
  },
  methods: {
    async extractPlayListWithPlayitems () {
      this.$emit('linkerJobStarted')
      this.saving = true
      const childrenIds = this.$store.state.Medium.playitems_selected_right.map(pi => pi.id)
      const newPlaylistMedium = {
        name: this.playlistName,
        type: this.choice,
        playListLayoutWidth: this.choice === 'PlayListLayout' ? this.layoutData.playListLayoutWidth : null,
        playListLayoutHeight: this.choice === 'PlayListLayout' ? this.layoutData.playListLayoutHeight : null
      }
      const selectedFolderId = this.$store.state.Medium.selected_library_folder.id
      const parentPlayListId = this.$store.state.Medium.media_selected_right[0].id
      await Vue.axios.post(`medium/extractPlayitemsIntoPlaylist`, {
        childrenIds, newPlaylistMedium, selectedFolderId, parentPlayListId
      })
      this.playlistName = ''
      this.saving = false
      this.layoutData = {
        playListLayoutWidth: 1920,
        playListLayoutHeight: 1080,
        type: 'PlayListLayout'
      }
      this.$emit('linkerJobDone')
    }
  },
  computed: {
    newPlayListHasName () {
      return this.playlistName.length > 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./dialog.scss";
</style>



// WEBPACK FOOTER //
// src/components/Linker/DialogExtractPlayitems.vue